import { Box, Divider, Flex, PageWrapper, Spacing } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useContentGridColumns } from './resources/hooks/useContentGridColumns';

const Loading = memo(() => {
    const { columns } = useContentGridColumns();

    return (
        <PageWrapper>
            <PageWrapper.Content spacingTop={0} spacingBottom={0}>
                <Flex height='100%' grow={1} block>
                    <Flex wrap={false} height='100%' spacing='0'>
                        <Flex grow={1} block>
                            <Box spacing='0 40 0 0'>
                                <Spacing height={16} />

                                <Flex block>
                                    <Skeleton width='30%' height={20} />
                                </Flex>

                                <Spacing height={16} />

                                <Flex container spacing='16' alignItems='stretch'>
                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>

                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>

                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>

                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>
                                </Flex>

                                <Spacing height={24} />

                                <Flex block>
                                    <Skeleton width='30%' height={20} />
                                </Flex>

                                <Spacing height={16} />

                                <Flex container spacing='16' alignItems='stretch'>
                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>

                                    <Flex size={columns === 2 ? 12 : 24} block>
                                        <Skeleton width='100%' height={150} />
                                    </Flex>
                                </Flex>

                                <Spacing height={40} />
                            </Box>
                        </Flex>

                        <Divider color='midnight50' orientation='vertical' />

                        <Flex grow={0} shrink={0} block>
                            <Box width={340} spacing='16 0 16 24'>
                                <Flex spacing='16' direction='column' wrap>
                                    <Flex block>
                                        <Skeleton width='40%' height={12} />

                                        <Skeleton width='100%' height={28} />
                                    </Flex>

                                    <Flex block>
                                        <Skeleton width='60%' height={12} />

                                        <Skeleton width='100%' height={28} />
                                    </Flex>

                                    <Flex block>
                                        <Skeleton width='30%' height={12} />

                                        <Skeleton width='100%' height={28} />
                                    </Flex>

                                    <Flex block>
                                        <Skeleton width='20%' height={12} />

                                        <Skeleton width='50%' height={28} />
                                    </Flex>
                                </Flex>

                                <Spacing height={24} />

                                <Flex spacing='16' alignItems='center'>
                                    <Flex shrink={0} grow={0} block>
                                        <Skeleton width={20} height={20} />
                                    </Flex>

                                    <Flex shrink={0} grow={1} block>
                                        <Skeleton width='100%' height={40} />
                                    </Flex>
                                </Flex>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>
            </PageWrapper.Content>
        </PageWrapper>
    );
});

export default Loading;
